<template>
    <svg width="46" height="21" viewBox="0 0 46 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2C0 0.89543 0.895431 0 2 0H37.1189C37.8859 0 38.6367 0.220521 39.2819 0.635286L45.0815 4.36359C45.654 4.7316 46 5.36542 46 6.04595V19C46 20.1046 45.1046 21 44 21H7.05234C6.14406 21 5.26282 20.6909 4.55356 20.1235L0.75061 17.0811C0.27618 16.7016 0 16.1269 0 15.5194V2ZM3.60596 2L6.38374 4.5H8.24853C8.9752 4.5 9.67717 4.76375 10.224 5.24227L13.093 7.75258C13.2753 7.91208 13.5092 8 13.7515 8H36.3696C36.5747 8 36.7749 7.93689 36.943 7.81923L40.9101 5.0423C41.1784 4.85449 41.4739 4.71301 41.7845 4.62173L37.7063 2H3.60596ZM44 6.5H42.6304C42.4253 6.5 42.2251 6.56311 42.057 6.68077L38.0899 9.4577C37.5857 9.81067 36.9851 10 36.3696 10H13.7515C13.0248 10 12.3228 9.73625 11.776 9.25773L8.90703 6.74742C8.72474 6.58792 8.49075 6.5 8.24853 6.5H7V19H44V6.5ZM5 17.9194V5.94536L2 3.24536V15.5194L5 17.9194Z" fill="currentColor"/>
    </svg>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

</style>
